import {Action} from "@ngrx/store";

export const LOAD_ECOMMERCE_SETUP_LIST: string = '[ecommerce setup] Load Ecommerce Setup List';
export const LOAD_ECOMMERCE_SETUP_SUCCESS: string = '[ecommerce setup] Load Ecommerce Setup List Success';
export const LOAD_ECOMMERCE_SETUP_FAIL: string = '[ecommerce setup] Load Ecommerce Setup List Fail';

export class LoadEcommerceSetupList implements Action {
  readonly type: string = LOAD_ECOMMERCE_SETUP_LIST;

  constructor(public payload: { websiteId: number }) {
  }
}

export class LoadEcommerceSetupListSuccess implements Action {
  readonly type: string = LOAD_ECOMMERCE_SETUP_SUCCESS;

  constructor(public payload: any) {
  }
}

export class LoadEcommerceSetupListFails implements Action {
  readonly type: string = LOAD_ECOMMERCE_SETUP_FAIL;

  constructor(public payload: any) {
  }
}

export type EcommerceSetupListAction =
  LoadEcommerceSetupList
  | LoadEcommerceSetupListSuccess
  | LoadEcommerceSetupListFails;
